<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>
      <div style="font-size: 20px;">{{ selectedStore.storeName }}</div>
      <div style="height: 30px;"></div>

      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="salesReportDate"
            :label="$t('sales.sales-date')"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        
        <v-date-picker
          v-model="salesReportDateForPicker"
          @input="menu2 = false"
          locale="jp-ja"
          :day-format="date => new Date(date).getDate()"
          no-title
          :events="functionEvents"
          event-color="green lighten-1"
          @change="onChangeSalesReportDate()"
        ></v-date-picker>
      </v-menu>
      <!-- 판매원 검색 -->
      <v-select
        v-model="reportedUsers"
        :items="reportedUsers"
        :label="$t('sales.salesperson')"
        persistent-hint
        prepend-icon="group"
        multiple
        chips
        disabled
        return-object
        v-if="isReported"
      ></v-select>

      <v-autocomplete
        v-model="selectedUsers"
        :items="salesUsers"
        item-text="userName"
        :label="$t('sales.salesperson')"
        persistent-hint
        prepend-icon="group"
        multiple
        chips
        deletable-chips
        return-object
        v-else
      ></v-autocomplete>

      <div style="height: 35px;"></div>

      <v-card>
        <v-container>
          <v-card-title>{{ $t('title.sales-report') }}</v-card-title>

          <v-flex xs12 sm12 v-if="isReported">
            <v-alert
              :value="true"
              color="warning"
              icon="info"
              outline
              class="font-weight-bold"
              style="text-align: left;"
            >報告済</v-alert>
          </v-flex>

          <div style="height: 30px;"></div>

          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-text-field
                type="Number"
                min="0"
                v-model="search"
                append-icon="search"
                :label="$t('sales.stocktaking-search')"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>

            <div style="height: 35px;"></div>

            <v-data-table
              id="dt"
              :headers="headers"
              :items="reportItems"
              hide-actions
              class="elevation-1"
              style="width: 100%; margin: 15px 0 0;"
              :customFilter="customFilter"
              :search="search"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <template v-slot:items="props">
                <tr
                  v-bind:class="{
                    'confirmed-items': isReported
                  }"
                >
                  <!-- 위의 tr태그 안에 포함 @click="editItem(props.item)" -->
                   <td class="jan-code-cell">
                    {{ props.item.janCode }}
                  </td>
                  <td class="product-name-cell">
                    <div class="product-name-text">
                      {{ props.item.itemName }}
                    </div>
                  </td>
                  <td class="text-xs-right px-2">
                    {{ Number(props.item.unitPrice || 0).toLocaleString() }}
                  </td>
                  <td class="sales-quantity-cell">
                    <input
                      type="number"
                      v-model.number="props.item.quantity"
                      class="column-input-for-order sales-quantity-input"
                      @change="editItem(props.item)"
                      min="0"
                    />
                  </td>
                  <td class="text-xs-right px-2">
                    {{ props.item.presentQuantity }}
                  </td>
                  <!-- 추가: 수량 * 단가 -->
                   <td class="text-xs-right px-2">
                    {{ Number(props.item.unitPrice) * Number(props.item.quantity) }}
                  </td>
                </tr>
              </template>
            </v-data-table>

              <!--　// del 20231013 kium 入力ダイアログ 
              <v-dialog v-model="updateDialog" max-width="500px">
              <v-card>
                <v-card-title
                  class="headline grey lighten-2 pa-3"
                >{{ $t('sales.sales-report-input') }}</v-card-title>
                <v-container>
                  <v-container grid-list-md>
                    <v-layout row warp>
                      <p class="font-weight-bold text-xs-left">
                        {{ $t('sales.product-name') }}:
                        {{ this.editedItem.itemName }}
                      </p>
                    </v-layout>
                    <v-layout row warp align-content-center>

                      아래 구문은 원래 주석처리 되어 있었음
                      <p class="font-weight-bold">参考在庫: 100</p>

                      <v-flex xs5 sm5>
                        <v-text-field
                          v-model="editedItem.referenceStock"
                          value="0"
                          :label="$t('attributes.reference-stock')"
                          type="number"
                          min="0"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <div style="height: 10px;"></div>
                    <v-divider></v-divider>
                    <v-layout row wrap justify-space-between align-center>
                      <v-flex xs5 sm5>
                        <v-text-field
                          v-model="editedItem.quantity"
                          value="0"
                          :label="$t('attributes.sales-number')"
                          type="number"
                          min="0"
                          @click="editedItem.quantity = ''"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs5 sm5>
                        <v-text-field
                          v-model="editedItem.presentQuantity"
                          value="0"
                          :label="$t('attributes.present')"
                          type="number"
                          min="0"
                          @click="editedItem.presentQuantity = ''"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                  </v-container>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close">
                      <v-icon dark>arrow_back</v-icon>
                      {{ $t('back-btn') }}
                    </v-btn>
                    <v-btn color="blue darken-1" flat @click="updateQuantity()">
                      <v-icon dark>save</v-icon>
                      {{ $t('update-btn') }}
                    </v-btn>
                  </v-card-actions>
                </v-container>
              </v-card>
            </v-dialog> 
            -->

            <v-flex xs12 sm12>
              <div style="height: 30px;"></div>
            </v-flex>

            <v-flex xs12 sm12>
              <v-textarea
                outline
                v-model="comments"
                counter="1000"
                :label="$t('attributes.comments')"
                clearable
                v-bind:readonly="isReported"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>

      <div style="height: 35px;"></div>
      <!-- ボタン：入力内容を確認する -->
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn
            block
            color="#4C728A"
            dark
            @click="forwardConfirm()"
            :disabled="isReported"
          >{{ $t('attributes.confirm-btn') }}</v-btn>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'sales/new-user-menu' }">
            <v-icon dark left>arrow_back</v-icon>
            {{ $t('back-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import moment from 'moment-timezone'
import XLSX from 'xlsx'

export default {
  created() {
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    this.getSalesReportItems()
    this.existSalesReport()
  },
  computed: {
    ...mapState({
      user: state => state.user,
      selectedStore: state => state.salesSession.menuSelectedStore
    }),
    salesReportDate: {
      get() {
        return this.$store.state.salesSession.salesReportDate
      },
      set(value) {
        this.$store.commit('SET_SALES_REPORT_DATE', value)
      }
    },
    updatedReportItems: {
      get() {
        return this.$store.state.salesSession.salesReportItems
      },
      set(value) {
        this.$store.commit('SET_SALES_REPORT_ITEMS', value)
      }
    },
    selectedUsers: {
      get() {
        return this.$store.state.salesSession.selectedUsers
      },
      set(value) {
        this.$store.commit('SET_SELECTED_USERS', value)
      }
    },
    comments: {
      get() {
        return this.$store.state.salesSession.comments
      },
      set(value) {
        this.$store.commit('SET_REPORT_COMMENTS', value)
      }
    }
  },
  methods: {
    customFilter(items, search) {
      if (!search) {
        return items;
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.janCode.includes(search)) {
            return true;
          } else {
            return false;
          }
        })
        return filteringItems;
      }
    },
    getSalesReportItems() {
      let thisObj = this;

      let request = {
        storeCode: this.selectedStore.storeCode,
        salesReportDate: this.salesReportDate.replace(/\//g, '')
      }

      ServerApiCallService.salesReportItems(request)
        .then(response => {
          thisObj.isReported = response.data.isReported;

          if (thisObj.isReported) {
            thisObj.reportItems = response.data.reportedItems;

            if (response.data.workedUsers) {
              thisObj.reportedUsers = []
              response.data.workedUsers.forEach(function(row) {
                var reportedUser = row.userId + ' ' + row.createdUser
                thisObj.reportedUsers.push(reportedUser)
              })
            }

            thisObj.comments = response.data.reportedItems[0].comments
          } else {
            thisObj.reportItems = response.data.items

            response.data.users.forEach(function(row) {
              var userList = {}
              if (!row.firstName) {
                userList = {
                  userId: row.userId,
                  userName: row.userId + ' ' + row.lastName
                }
              } else {
                userList = {
                  userId: row.userId,
                  userName:
                    row.userId + ' ' + row.lastName + ' ' + row.firstName
                }
              }

              thisObj.salesUsers.push(userList);
            })
          }

          // 商品の表示順 商品カテゴリ、商品名
          thisObj.reportItems.sort(function(a, b) {
            if (a.itemName > b.itemName) return 1
            if (a.itemName < b.itemName) return -1
            // a must be equal to b
            return 0
          })
          thisObj.reportItems.sort(function(a, b) {
            if (a.itemCategoryId > b.itemCategoryId) return 1
            if (a.itemCategoryId < b.itemCategoryId) return -1
            // a must be equal to b
            return 0
          })

          // 売上報告確認画面から戻った場合の処理
          if (this.updatedReportItems.length != 0) {
            thisObj.updatedReportItems.forEach(function(updatedItem) {
              thisObj.reportItems.forEach(function(item) {
                if (updatedItem.itemCode == item.itemCode) {
                  item.quantity = updatedItem.quantity
                  item.presentQuantity = updatedItem.presentQuantity
                  item.referenceStock = updatedItem.referenceStock
                }
              })
            })
          }
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },
    onChangeSalesReportDate() {
      this.$store.commit('SET_SELECTED_USERS', '')
      this.$store.commit('SET_REPORT_COMMENTS', '')
      this.$store.commit('SET_SALES_REPORT_ITEMS', '')

      this.salesReportDate = this.salesReportDateForPicker.replace(/-/g, '/')

      this.getSalesReportItems()
      this.existSalesReport()
    },
    forwardConfirm() {
      let itemsFilterlingReportNum = this.reportItems.filter(
        item => item.quantity > 0 || item.presentQuantity > 0
      )

      this.updatedReportItems = itemsFilterlingReportNum

      // 売上日チェック
      if (this.salesReportDate === '') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.non-selected-report-date')
        )
        return;
      }
      // 販売員チェック
      if (!this.selectedUsers) {
        this.$parent.$parent.$parent.showErrorDialog('販売員を選択してください')
        return;
      }
      // 상품의 수량을 입력했는지 체크
      if (itemsFilterlingReportNum.length == 0) {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.non-selected-order-items')
        )
        return;
      }

      // del 20231013 kium
      // if (this.updatedReportItems.length == 0) {
      //   this.$parent.$parent.$parent.showErrorDialog(
      //     this.$t('sales.non-selected-order-items')
      //   )
      //   return;
      // }

      // 확인 페이지로 이동
      this.$router.push({
        name: 'sales/SalesReportConfirm',
        params: {}
      })
    },

    // 売上報告済の確認
    existSalesReport() {
      var requestSalesReportDate = ''

      if (!this.salesReportDateForPicker) {
        requestSalesReportDate = moment().format('YYYYMMDD')
      } else {
        requestSalesReportDate = moment(this.salesReportDateForPicker).format(
          'YYYYMMDD'
        )
      }

      let request = {
        storeCode: this.selectedStore.storeCode,
        salesReportDate: requestSalesReportDate
      }

      ServerApiCallService.existSalesReportByUser(request)
        .then(response => {
          this.existsSalesReportData = response.data.existSalesReports
        })
        .catch(error => {})
    },
    functionEvents(date) {
      var day = date.replace(/-/g, '')
      if (this.existsSalesReportData.includes(day)) return true
    },
    editItem(item) {
      if (this.isReported) {
        return
      }

      // del 20231013 kium
      // // 판매일 체크
      // if (this.salesReportDate === '') {
      //   this.$parent.$parent.$parent.showErrorDialog(
      //     this.$t('sales.non-selected-report-date')
      //   )
      //   return;
      // }

      this.editedItem = Object.assign({}, item);
      // add 20231013 kium
      this.updateQuantity();
      // del 20231013 kium
      // this.updateDialog = true;
    },
    close() {
      // del 20231013 kium
      // this.updateDialog = false;
    },
    updateQuantity() {
      let thisObj = this;

      this.reportItems.forEach(function(row) {
        if (row.itemCode == thisObj.editedItem.itemCode) {
          row.quantity = Number(thisObj.editedItem.quantity);
          row.presentQuantity = Number(thisObj.editedItem.presentQuantity);
          row.referenceStock = Number(thisObj.editedItem.referenceStock);
        }
      })
      // del 20231013 kium
      // this.updateDialog = false;
    }
  },
  data() {
    return {
      isReported: false,
      updateDialog: false,
      menu2: false,
      dispShippingConfirmBtn: false,
      search: '',
      salesReportDateForPicker: '',
      reportedUsers: [],
      editedItem: [],
      selectedReportItems: [],
      itemCategories: [],
      reportItems: [],
      existsSalesReportData: [],
      headers: [
        {
          text: 'JANコード',
          align: 'left',
          value: 'itemCode',
          width: '16%',
          sortable: false,
          class: 'jan-code-header'
        },
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          width: '34%',
          sortable: false,
          class: 'product-name-header'
        },
        {
          text: this.$t('attributes.unitPrice'),
          align: 'right',
          value: 'unitPrice',
          width: '10%',
          sortable: false,
          class: 'unit-price-header'
        },
        {
          text: this.$t('attributes.sales-number'),
          align: 'right',
          value: 'orderLimit',
          width: '14%',
          sortable: false,
          class: 'sales-quantity-header'
        },
        {
          text: this.$t('attributes.present'),
          align: 'right',
          value: 'presentQuantity',
          width: '13%',
          sortable: false,
          class: 'present-header'
        },
        {
          text: this.$t('attributes.subTotal'),
          align: 'right',
          value: 'subTotal',
          width: '13%',
          sortable: false,
          class: 'subtotal-header'
        }
      ],
      salesReportConfirmHeader: [
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false
        },
        {
          text: this.$t('attributes.sales-number'),
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true
        },
        {
          text: this.$t('attributes.present'),
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true
        }
      ],
      workedUsers: [],
      salesUsers: [],
      reportSum: 0,
      fileName: '',
      file: '',
      loading1: false,
    }
  }
}
</script>

<!-- <style>
#dt tr:nth-child(even) {
  background-color: #f2f2f2;
}

.confirmed-items {
  background-color: #adadad;
} -->

<style>
#dt table {
  width: 100%;
  table-layout: fixed;
}

#dt tr:nth-child(even) {
  background-color: #f2f2f2;
}

.confirmed-items {
  background-color: #adadad;
}

/* 모든 헤더와 셀의 기본 좌우 여백 */
#dt th,
#dt td {
  box-sizing: border-box;
  vertical-align: middle;
}

/* JAN 코드 */
#dt th.jan-code-header,
#dt td.jan-code-cell {
  padding-left: 8px !important;
  padding-right: 8px !important;
  text-align: left !important;
  white-space: nowrap;
}

/* JAN 코드와 상품명 사이의 간격 */
#dt th.product-name-header,
#dt td.product-name-cell {
  padding-left: 18px !important;
  padding-right: 8px !important;
  text-align: left !important;
}

/* 상품명 최대 2줄 */
.product-name-text {
  display: -webkit-box;
  overflow: hidden;
  line-height: 20px;
  max-height: 40px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

/* 매출 개수 헤더 */
#dt th.sales-quantity-header {
  padding-left: 8px !important;
  padding-right: 8px !important;
  text-align: right !important;
}

/* 매출 개수 셀 */
#dt td.sales-quantity-cell {
  padding-left: 8px !important;
  padding-right: 8px !important;
  text-align: right !important;
}

/* input이 셀 전체 너비를 사용하도록 설정 */
#dt .sales-quantity-input {
  display: block;
  width: 100% !important;
  height: 32px;
  padding: 0 !important;
  margin: 0 !important;
  border: 0;
  outline: none;
  background: transparent;
  box-sizing: border-box;
  text-align: right !important;
  font: inherit;
}
</style>
